<!-- 医院信息管理 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                        :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                        @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false"
                                    :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey" v-if="formOneValue.isShow == 1"
                                            :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <el-input v-if="formOneValue.fieldType == 'search'"
                                                :disabled="formOneValue.isChange == 0" clearable
                                                v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField, formOneValue.isIndex)">
                                                <el-button
                                                    @click="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField, formOneValue.isIndex)"
                                                    slot="append" icon="el-icon-search"></el-button>
                                            </el-input>
                                            <df-date :isdisabled="formOneValue.isChange == 0"
                                                v-else-if="formOneValue.fieldType == 'date'"
                                                :isShowLong="formOneValue.entityField == 'glTervalidity' ? true : false"
                                                @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                :maxlength="$store.state.inputLength"
                                                @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                :disabled="formOneValue.isChange == 0" clearable></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'"
                                            v-if="formOneValue.isShow == 1"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                    sendDataInfo[formOneValue.entityField] }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                {{ getValue(sendDataInfo[formOneValue.entityField],
                                                    formOneValue.entityField, formOneValue.fieldType,
                                                    formOneValue.formatterContent) }}
                                            </span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <!-- 页脚 -->
                <div class="foots">
                    <div>
                        <el-button @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">保存</el-button>
                    </div>
                    <div v-if="footForm">
                        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                                <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel"
                :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "basebrandAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            imgUrl: window.global_config.BASE_IMG_URL,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            selectedDetailsIndex: 0, //选择索引
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            parentSearchData: {},
            seIndex: 0,
            fField: "",
            seType: "",
            seId: "",
            setField: "",
            inputel: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.manufacturer"(){
            if (this.sendDataInfo.manufacturer=="") {
                this.sendDataInfo.manuId = ""
                this.sendDataInfo.bgiProlicense = ""
                this.sendDataInfo.glTervalidity = ""
            }
        }
    },
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch(sId, setField, type, index) {
            this.seId = sId;
            this.setField = setField
            this.seType = type;
            this.seIndex = index
            this.parentSearchData = this.sendDataInfo
            this.DialogVisible = true;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            if (this.setField != null && this.setField != '' && this.setField != undefined) {
                let arr = this.setField.split(',')
                arr.forEach(item => {
                    this.sendDataInfo[item] = val[item]
                })
            } else {
                this.sendDataInfo[this.seType] = val[this.seType]
            }
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 确认新增
        async sendDataAction(formName) {
            let flag = false;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.basebrandadd(sendData);
            } else {
                var responseData = await this.$http.basebrandupdate(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消新增
        initActionBox(formName) {
            this.$confirm("确定取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.init();
                    this.$emit("drawerCancel", 0);
                    this.$refs[formName].resetFields();
                })
                .catch(() => { });
        },

        async isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                this.addDetails("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;

            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                return;
            }
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });

            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var obj = this.$common.filterMainFields(
                this.formDataList,
                [],
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.showTabs = this.tabForm[0].jciName;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-drawer {
    outline: none;
}
</style>